<template>
  <b-container>
    <b-row class="m-0">
      <b-col md="1" />
      <b-col
        lg="10"
        class="d-flex align-items-center justify-content-center px-2 p-lg-5"
      >
        <b-col
          sm="12"
          md="12"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <validation-observer ref="experimentForm">
            <b-form @submit.prevent="submitExperiment">
              <b-row>
                <b-col md="6">
                  <b-form-group
                    label="Experiment Name"
                    label-for="experiment-name"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Experiment Name"
                      vid="experiment-name"
                      rules="required"
                    >
                      <b-form-input
                        id="experiment-name"
                        v-model="experimentForm.name"
                        placeholder="Experiment Name"
                        :state="errors.length ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group
                    label="Experiment Description"
                    label-for="experiment-description"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Experiment Description"
                      vid="experiment-description"
                      rules="required"
                    >
                      <b-form-textarea
                        id="experiment-description"
                        v-model="experimentForm.description"
                        placeholder="Experiment Description"
                        :state="errors.length ? false : null"
                        rows="3"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group
                    label="Experiment Current Version"
                    label-for="experiment-current-version"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Experiment Current Version"
                      vid="experiment-current-version"
                      rules="required"
                    >
                      <b-form-input
                        id="experiment-current-version"
                        v-model="experimentForm.current_version"
                        placeholder="Experiment Current Version"
                        :state="errors.length ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group
                    label="Category *"
                    label-for="category_id"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Experiment Category"
                      vid="experiment-category"
                      rules="required"
                    >
                      <v-select
                        id="category_id"
                        v-model="experimentForm.category_id"
                        :options="categories"
                        class="w-100 mb-0 custom-field"
                        :reduce="(val) => val.id"
                        placeholder="Select Category"
                        :label="$i18n.locale == 'en' ? 'name' : 'name_local'"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group
                    label="Status *"
                    label-for="status_id"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Experiment Status"
                      vid="experiment-status"
                      rules="required"
                    >
                      <v-select
                        id="status_id"
                        v-model="experimentForm.status"
                        :options="statusLookups"
                        class="w-100 mb-0 custom-field"
                        :reduce="(val) => val"
                        placeholder="Select Status"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group
                    label="Experiment Target Package"
                    label-for="experiment-target-package"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Experiment Target Package"
                      vid="experiment-target-package"
                      rules="required"
                    >
                      <b-form-input
                        id="experiment-target-package"
                        v-model="experimentForm.targetPackage"
                        placeholder="Experiment Target Package"
                        :state="errors.length ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group
                    label="Experiment Prompt"
                    label-for="experiment-prompt"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Experiment Prompt"
                      vid="experiment-prompt"
                      rules="required"
                    >
                      <b-form-textarea
                        id="experiment-prompt"
                        v-model="experimentForm.prompt"
                        placeholder="Experiment Prompt"
                        :state="errors.length ? false : null"
                        rows="3"
                      />

                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group
                    label="Experiment Publish URL"
                    label-for="experiment-publish-url"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Experiment Publish URL"
                      vid="experiment-publish-url"
                      rules="required|url"
                    >
                      <b-form-input
                        id="experiment-publish-url"
                        v-model="experimentForm.publish_URL"
                        placeholder="Experiment Publish URL"
                        :state="errors.length ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group
                    class="mt-2"
                    label="Badges"
                    label-for="experiment-featured-new"
                  >
                    <div class="d-flex align-items-center">
                      <b-form-checkbox
                        id="experiment-is-pinned"
                        v-model="experimentForm.is_pinned"
                        :value="1"
                        :unchecked-value="0"
                        class="mr-2"
                      >
                        Pinned
                      </b-form-checkbox>
                      <b-form-checkbox
                        id="experiment-is-featured"
                        v-model="experimentForm.is_featured"
                        :value="1"
                        :unchecked-value="0"
                        class="mr-2"
                      >
                        Featured
                      </b-form-checkbox>
                      <b-form-checkbox
                        id="experiment-is-new"
                        v-model="experimentForm.is_new"
                        :value="1"
                        :unchecked-value="0"
                      >
                        New
                      </b-form-checkbox>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col
                  v-if="!experimentForm.image"
                  md="6"
                >
                  <b-form-group
                    label="Experiment Image"
                    label-for="experiment-image"
                    description="Max upload Size 2 MB"
                  >
                    <ValidationProvider
                      v-slot="{ errors, validate }"
                      rules="required|image"
                      name="Experiment Image"
                    >
                      <b-form-file
                        id="experiment-image"
                        v-model="experimentForm.image"
                        name="experiment-image"
                        placeholder="Upload Image"
                        drop-placeholder="Drop image here..."
                        accept=".jpg,.jpeg,.png,.pdf"
                        @change="onImageChange($event, validate)"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </b-form-group>
                </b-col>

                <b-col
                  v-else
                  md="6"
                >
                  <div class="main-image-preview-wrapper">
                    <!-- Hidden input to allow changing image while preview is shown -->
                    <input
                      ref="mainImageInput"
                      type="file"
                      class="d-none"
                      accept=".jpg,.jpeg,.png,.pdf"
                      @change="onImageChange($event)"
                    >

                    <img
                      :src="isString(experimentForm.image) ? experimentForm.image : experimentForm.imagePreview"
                      alt="image"
                      class="w-100"
                    >

                    <div class="main-image-actions-overlay">
                      <div class="main-image-actions">
                        <button
                          type="button"
                          class="btn btn-primary btn-sm mb-0"
                          @click.prevent="$refs.mainImageInput && $refs.mainImageInput.click()"
                        >
                          Change
                        </button>
                        <button
                          type="button"
                          class="btn btn-danger btn-sm mb-0"
                          @click.prevent="removeImage"
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>
                </b-col>

                <b-col md="12">
                  <b-form-group
                    label="Experiment Media (Maximum 3 files)"
                    label-for="media"
                  >
                    <small class="text-muted d-block mb-2">
                      Images: max 2MB | Videos: max 10MB
                    </small>

                    <!-- Media Slots -->
                    <b-row>

                      <b-col
                        v-for="(slot, index) in mediaSlots"
                        :key="index"
                        md="4"
                        class="mb-3"
                      >
                        <div
                          class="media-slot-container"
                          :class="{ 'has-media': slot.hasMedia }"
                        >
                          <!-- Preview Area -->
                          <div
                            v-if="slot.hasMedia"
                            class="media-preview-wrapper"
                          >
                            <img
                              v-if="!slot.type || slot.type.startsWith('image/')"
                              :src="slot.url"
                              class="media-preview-img"
                              alt="Media preview"
                            >

                            <video
                              v-else
                              controls
                              class="media-preview-video"
                            >
                              <source :src="slot.url">
                            </video>

                            <!-- Change Button -->
                            <div class="change-overlay">
                              <div class="overlay-actions">
                                <label
                                  :for="`media-input-${index}`"
                                  class="btn btn-primary btn-sm mb-0"
                                >
                                  Change
                                </label>
                                <button
                                  type="button"
                                  class="btn btn-danger btn-sm mb-0"
                                  :title="slot.id ? 'Delete media' : 'Remove file'"
                                  @click.prevent="slot.id ? checkDelete(slot.id, index) : removeMediaSlot(index)"
                                >
                                  Delete
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Upload Area -->
                          <div
                            v-else
                            class="upload-area"
                          >
                            <label
                              :for="`media-input-${index}`"
                              class="upload-label"
                            >
                              <i class="feather icon-upload" />
                              <span>Upload Media {{ index + 1 }}</span>
                            </label>
                          </div>

                          <!-- Hidden File Input -->
                          <ValidationProvider
                            :ref="`mediaProvider${index}`"
                            v-slot="{ errors, validate }"
                            :rules="getMediaRules(index)"
                            :name="`Media ${index + 1}`"
                          >
                            <input
                              :id="`media-input-${index}`"
                              type="file"
                              class="d-none"
                              accept=".jpg,.jpeg,.png,.gif,.mp4,.mov,.avi,.wmv"
                              @change="onMediaSlotChange($event, index, validate,slot.id)"
                            >
                            <small class="text-danger d-block mt-1">{{ errors[0] }}</small>
                          </ValidationProvider>
                        </div>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row class="w-100 d-flex align-items-center justify-content-center p-0 py-50">
                <b-button
                  type="submit"
                  variant="primary"
                  :disabled="isLoading"
                  style="background-color:#727272!important;border:unset!important;width:200px;"
                  @click="submitExperiment"
                >
                  <b-spinner
                    v-if="isLoading"
                    variant="light"
                  />
                  <span v-else>{{ experimentID ? "Update" : "Create" }}</span>
                </b-button>
              </b-row>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
      <b-col md="1" />
    </b-row>
  </b-container>
</template>

<script>
import { required, image, url } from '@validations'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'

import {
  BSpinner,
  BContainer,
  BRow,
  BCol,
  BForm,
  BFormFile,
  BFormInput,
  BFormGroup,
  BButton,
  BFormTextarea,
  BFormCheckbox,
} from 'bootstrap-vue'

extend('single_media_file', {
  validate: file => {
    if (!file) return true // Optional validation

    const imageTypes = ['image/jpeg', 'image/png', 'image/gif']
    const videoTypes = ['video/mp4', 'video/quicktime', 'video/x-msvideo', 'video/x-ms-wmv']

    const maxImageSize = 1024 * 1024 * 2 // 2MB
    const maxVideoSize = 1024 * 1024 * 10 // 10MB

    if (imageTypes.includes(file.type)) {
      if (file.size > maxImageSize) {
        return `Image must be less than 2MB. This file is ${(file.size / 1024 / 1024).toFixed(2)}MB.`
      }
    } else if (videoTypes.includes(file.type)) {
      if (file.size > maxVideoSize) {
        return `Video must be less than 10MB. This file is ${(file.size / 1024 / 1024).toFixed(2)}MB.`
      }
    } else {
      return 'Invalid file type. Only images (JPG, PNG, GIF) and videos (MP4, MOV, AVI, WMV) are allowed.'
    }

    return true
  },
  message: 'Invalid file.',
})

export default {
  components: {
    vSelect,
    BSpinner,
    BContainer,
    BRow,
    BCol,
    BForm,
    BFormTextarea,
    BFormGroup,
    BFormInput,
    BFormFile,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
  },
  computed: {
    ...mapGetters({
      item: 'experiments/item',
      categories: 'categories/lookups',
      statusLookups: 'experiments/statusLookups',
    }),
    experimentID() {
      return this.$route.params.id || null
    },
  },
  data() {
    return {
      isLoading: false,
      experimentForm: {
        name: '',
        description: '',
        prompt: '',
        de_images_ids: [],
        current_version: '',
        category_id: null,
        targetPackage: '',
        publish_URL: null,
        status: '',
        is_featured: 0,
        is_new: 0,
        is_pinned: 0,
        image: null,
        imagePreview: null,
        publish_URL: null,
      },
      mediaSlots: [
        {
          hasMedia: false, url: null, type: null, file: null, id: null, isExisting: false,
        },
        {
          hasMedia: false, url: null, type: null, file: null, id: null, isExisting: false,
        },
        {
          hasMedia: false, url: null, type: null, file: null, id: null, isExisting: false,
        },
      ],
      required,
      image,
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    // Clean up object URLs
    this.mediaSlots.forEach(slot => {
      if (slot.url && !slot.isExisting) {
        URL.revokeObjectURL(slot.url)
      }
    })
  },
  methods: {
    isString(value) {
      return typeof value === 'string'
    },

    getMediaRules(index) {
      // Make first slot required only if no media exists
      if (index === 0) {
        const hasAnyMedia = this.mediaSlots.some(slot => slot.hasMedia)
        return hasAnyMedia ? 'single_media_file' : 'required|single_media_file'
      }
      return 'single_media_file'
    },

    onImageChange(event, validate) {
      const file = event.target.files[0]
      if (!file) return
      this.experimentForm.image = file
      this.experimentForm.imagePreview = URL.createObjectURL(file)
      if (typeof validate === 'function') validate()
      // allow selecting same file again
      if (event && event.target) event.target.value = null
    },

    removeImage() {
      this.experimentForm.image = null
      this.experimentForm.imagePreview = null
      if (this.$refs.mainImageInput) this.$refs.mainImageInput.value = null
    },

    onMediaSlotChange(event, slotIndex, validate, id = null) {
      const file = event.target.files[0]
      if (!file) return

      const slot = this.mediaSlots[slotIndex]

      // Revoke old URL if exists
      if (slot.url && !slot.isExisting) {
        URL.revokeObjectURL(slot.url)
      }
      if (id) {
        if (!Array.isArray(this.experimentForm.de_images_ids)) {
          this.$set(this.experimentForm, 'de_images_ids', [])
        }
        this.experimentForm.de_images_ids.push(id)
      }
      // Update slot
      this.$set(this.mediaSlots, slotIndex, {
        hasMedia: true,
        url: URL.createObjectURL(file),
        type: file.type,
        file,
        id: slot.id, // Keep existing ID if updating
        isExisting: false,
      })

      // Validate
      if (validate) validate(file)

      // Clear input
      event.target.value = null

      // Revalidate first slot if needed
      this.$nextTick(() => {
        const firstProvider = this.$refs.mediaProvider0
        const provider = Array.isArray(firstProvider) ? firstProvider[0] : firstProvider
        if (provider && typeof provider.validate === 'function') {
          provider.validate()
        }
      })
    },
    checkDelete(id, index) {
      this.removeMediaSlot(index)
      if (id) {
        if (!Array.isArray(this.experimentForm.de_images_ids)) {
          this.$set(this.experimentForm, 'de_images_ids', [])
        }
        this.experimentForm.de_images_ids.push(id)
      }
      // this.$swal.fire({
      //   title: 'Are you sure to delete?',
      //   icon: 'warning',
      //   showCancelButton: true,
      //   confirmButtonColor: '#7367f0',
      //   // cancelButtonColor: '#d33',
      //   confirmButtonText: 'Yes, delete it!',
      //   cancelButtonText: 'Cancel'
      // }).then((result) => {
      //   if (result.isConfirmed) {
      //     this.$store.dispatch("images/delete", id).then((res)=>{
      //       if(res.success){
      //         this.removeMediaSlot(index)
      //       }
      //     }).catch((err)=>{
      //       this.$swal.fire({
      //         title: 'Error!',
      //         text: err.message || 'Failed to delete item. Please try again.',
      //         icon: 'error',
      //         confirmButtonText: 'OK'
      //       })
      //     })
      //   }
      // })
    },

    removeMediaSlot(slotIndex) {
      const slot = this.mediaSlots[slotIndex]

      // Revoke URL if it's a new upload
      if (slot.url && !slot.isExisting) {
        URL.revokeObjectURL(slot.url)
      }

      // Reset slot
      this.$set(this.mediaSlots, slotIndex, {
        hasMedia: false,
        url: null,
        type: null,
        file: null,
        id: null,
        isExisting: false,
      })

      // Revalidate first slot
      this.$nextTick(() => {
        const firstProvider = this.$refs.mediaProvider0
        const provider = Array.isArray(firstProvider) ? firstProvider[0] : firstProvider
        if (provider && typeof provider.validate === 'function') {
          provider.validate()
        }
      })
    },

    submitExperiment() {
      this.$refs.experimentForm.validate().then(success => {
        if (!success) {
          this.$swal({
            icon: 'error',
            title: '<h4>Validation Error</h4>',
            text: 'Please check all required fields',
            confirmButtonColor: '#7367f0',
          })
          return
        }

        const formData = new FormData()
        formData.append('name', this.experimentForm.name)
        formData.append('description', this.experimentForm.description)
        formData.append('prompt', this.experimentForm.prompt)
        formData.append('category_id', this.experimentForm.category_id)
        formData.append('targetPackage', this.experimentForm.targetPackage)
        formData.append('publish_URL', this.experimentForm.publish_URL)
        formData.append('status', this.experimentForm.status)
        formData.append('current_version', this.experimentForm.current_version)
        formData.append('is_featured', this.experimentForm.is_featured)
        formData.append('is_new', this.experimentForm.is_new)
        formData.append('is_pinned', this.experimentForm.is_pinned)

        // Send deleted image ids as an array in multipart form-data
        if (Array.isArray(this.experimentForm.de_images_ids)) {
          this.experimentForm.de_images_ids.forEach(id => {
            if (id != null && id !== '') {
              formData.append('de_images_ids[]', String(id))
            }
          })
        }
        // Add main image
        if (this.experimentForm.image && this.experimentForm.image instanceof File) {
          formData.append('image', this.experimentForm.image)
        }

        // Add media files from slots
        this.mediaSlots.forEach((slot, index) => {
          if (slot.hasMedia && slot.file) {
            // New file uploaded
            formData.append('images[]', slot.file)
          } else if (slot.hasMedia && slot.isExisting && slot.id) {
            // Existing file kept (send ID to backend)
            formData.append('existing_images[]', slot.id)
          }
        })
        this.isLoading = true

        const action = this.experimentID
          ? this.$store.dispatch('experiments/update', {
            query: formData,
            id: this.experimentID,
          })
          : this.$store.dispatch('experiments/put', formData)

        action
          .then(() => {
            console.log('----------------------success')

            this.$swal({
              icon: 'success',
              title: `<h4>Experiment ${
                this.experimentID ? 'updated' : 'created'
              } successfully!</h4>`,
              confirmButtonColor: '#7367f0',
            })
            this.isLoading = false
            this.$router.push({ name: 'experiments' })
          })
          .catch(error => {
            this.isLoading = false
            this.$swal({
              icon: 'error',
              title: `<h4>${
                error.response?.data?.error || 'Unexpected error'
              }</h4>`,
              confirmButtonColor: '#7367f0',
            })
          })
      })
    },

    async init() {
      this.$store.dispatch('categories/categoryLookups')
      this.$store.dispatch('experiments/statusLookups')

      if (this.experimentID) {
        this.$store
          .dispatch('experiments/get', this.experimentID)
          .then(() => {
            const exp = this.item
            this.experimentForm = {
              name: exp.name,
              description: exp.description,
              prompt: exp.prompt,
              de_images_ids: [],
              current_version: exp.current_version,
              category_id: exp.category_id,
              targetPackage: exp.targetPackage,
              publish_URL: exp.publish_URL,
              status: exp.status,
              is_featured: exp.is_featured ? 1 : 0,
              is_new: exp.is_new ? 1 : 0,
              is_pinned: exp.is_pinned ? 1 : 0,
              image: exp.image || null,
              imagePreview: exp.image || null,
            }

            // Load existing media into slots
            if (exp.images && exp.images.length > 0) {
              exp.images.forEach((img, index) => {
                if (index < 3) {
                  this.mediaSlots[index] = {
                    hasMedia: true,
                    url: img.url,
                    type: img.type || 'image/jpeg',
                    file: null,
                    id: img.id,
                    isExisting: true,
                  }
                }
              })
            }
          })
          .catch(e => {
            this.$swal({
              icon: 'error',
              title: `<h4>Error fetching experiment details: ${e.message}</h4>`,
              confirmButtonColor: '#7367f0',
            })
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.media-slot-container {
  border: 2px dashed #444;
  border-radius: 8px;
  min-height: 220px;
  position: relative;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;

  &.has-media {
    border-color: #7367f0;
    border-style: solid;
  }

  &:hover {
    border-color: #7367f0;
  }
}

.media-preview-wrapper {
  position: relative;
  width: 100%;
  height: 220px;

  .remove-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 3;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    padding: 0;
    font-size: 20px;
    line-height: 1;
  }

  .media-preview-img,
  .media-preview-video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 6px;
  }

  .change-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.7);
    padding: 10px;
    text-align: center;
    opacity: 0;
    transition: opacity 0.3s ease;

    .overlay-actions {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
    }

    .overlay-actions .btn {
      white-space: nowrap;
    }

    label {
      margin: 0;
      cursor: pointer;
    }
  }

  &:hover .change-overlay {
    opacity: 1;
  }
}

.upload-area {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 220px;

  .upload-label {
    cursor: pointer;
    text-align: center;
    color: #aaa;
    transition: color 0.3s ease;

    i {
      font-size: 40px;
      display: block;
      margin-bottom: 10px;
    }

    span {
      display: block;
      font-size: 14px;
    }

    &:hover {
      color: #7367f0;
    }
  }
}

.main-image-preview-wrapper {
  position: relative;
}

.main-image-actions-overlay {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 10px;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.main-image-preview-wrapper:hover .main-image-actions-overlay {
  opacity: 1;
  pointer-events: auto;
}

.main-image-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";

[dir] .dark-layout input.form-control,
[dir] .dark-layout .custom-file-label,
[dir] .dark-layout textarea.form-control {
  height: 45px;
  box-shadow: black beige indigo;
  border-radius: 8px;
  box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.4);
  background: linear-gradient(
    90deg,
    rgba(158, 63, 217, 0.2) 0%,
    rgba(37, 78, 158, 0.2) 49%,
    rgba(70, 124, 227, 0.2) 100%
  );
  border: 2px solid #ffffff3c;
  border-left: none;
  border-right: none;
  border-top: none;
}
[dir] .dark-layout input.form-control:not(:focus),
[dir] .dark-layout .custom-file-label:not(:focus),
[dir] .dark-layout textarea.form-control:not(:focus) {
  border-color: #ffffff3c;
}

.form-group span {
  position: relative;
}

.field-icon {
  position: absolute;
  top: 10px;
  left: 30px;
  color: #ffffffcc !important;
  font-weight: 500;
}

.form-control::placeholder {
  color: #5e5873 !important;
  font-size: 16px;
  margin-top: 55px !important;
  font-weight: 300 !important;
}
</style>
